<template>
    <PatientProfile
        :patientId    = "patientInfo.id"
        :name         = "patientInfo.name"
        :birth        = "patientInfo.birth"
        :age          = "patientInfo.age"
        :weight       = "patientInfo.weight"
        :lastExam     = "patientInfo.lastExam"
        :painArea     = "patientInfo.painArea"
        :showPainArea = "true"
    />
    <hr style="border:0; border-top:1.5px solid #c8c8c8; margin:12px 0;" />
    <div class="exam-result-management">
        <!-- 검색/필터 영역 -->
        <!-- <Search :filter="filter" :options="options" @search="fetchExamResults"  @reset="onResetFilter"/> -->
         <div class="result-section">
            <table class="result-table">
                <colgroup>
                    <col style="width: 8%;">
                    <col style="width: 18%;">
                    <!-- <col style="width: 15%;"> -->
                    <col style="width: auto;">
                    <col style="width: 14%;">
                    <col style="width: 14%;">
                    <col style="width: 14%;">
                </colgroup>
                <thead>
                    <tr>
                        <th>no</th>
                        <th>측정일</th>
                        <!-- <th>질환명</th> -->
                        <th>부위</th>
                        <th>VAS</th>
                        <th>SCORE</th>
                        <th>통증 측정 내역</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="diagnosisList.length === 0">
                        <td colspan="6" style="color:#9ab2ca; text-align: center;">
                            측정 내역이 없습니다.
                        </td>
                    </tr>
                    <tr v-else v-for="item in diagnosisList" :key="item.id">
                        <td>{{ item.no }}</td>
                        <td>{{ item.examDate }}</td>
                        <!-- <td>{{ item.diseaseName }}</td> -->
                        <td>{{ item.part }}</td>
                        <td>
                            <!-- <span v-if="getVasFace(item.vas).emoji" :style="{ color: getVasFace(item.vas).color, fontSize: '20px' }">
                                {{ getVasFace(item.vas).emoji }}
                            </span> -->
                            <span v-if="getVasFace(item.vas)" style="margin-right:6px;">
                                <img
                                :src="require(`@/assets/resource/icon/${getVasFace(item.vas)}.png`)"
                                alt="vas"
                                style="width:27px; height:auto; vertical-align: middle;"
                                />
                            </span>
                            {{ item.vas }}
                        </td>
                        <td>{{ item.score }}</td>
                        <td>
                            <button @click="showDetail(item)" class="detail-btn">통증 프로파일</button>
                        </td>
                    </tr>
                </tbody>
            </table>
            <pagination
                :total-items="totalCount"
                :page-size="pageSize"
                v-model="currentPage"
                @page-change="onPageChange"
            />
         </div>
    </div>
</template>
<script setup>
    defineOptions({
        meta: {
            title       : '통증 측정 내역',
            segmentKey  : 'patientId',
            filter      : 'DiagnosisListFilter',
            page        : 'DiagnosisListPage',
        }
    })

    import PatientProfile                              from "@/components/common/PatientProfile.vue"
    import {ref, onMounted, reactive, computed, watch} from 'vue'
    import {useRouter, useRoute}                       from "vue-router";
    import api, {urls}                                 from "@/api";
    import Pagination                                  from "@/components/common/Pagination.vue";
    import Search                                      from "../common/Search.vue";
    import { commonUtils }                             from "@/utils/commonUtils";

    const options = [
        // {value: "diseaseName", label: '질환명'},
        {value: "painArea", label: '부위'},
        {value: "vasScore", label: 'VAS'},
        {value: "score", label: 'SCORE'},
    ]
    const router        = useRouter()
    const route         = useRoute()
    const diagnosisList = ref([])
    const filter        = reactive({
        searchType: "all",
        searchText: "",
        startDate: "",
        endDate: "",
    })

    const currentPage = ref(Number(sessionStorage.getItem('DiagnosisListPage') || 1));
    const pageSize    = ref(10)
    const totalPages  = ref(1)
    const totalCount  = ref(0)
    const patientInfo = ref({})

    // const vasFaces = [
    //     { score: 10, emoji: "😀", color: "#39c346" },
    //     { score: 20, emoji: "😊", color: "#7fd454" },
    //     { score: 30, emoji: "🙂", color: "#b6dc65" },
    //     { score: 40, emoji: "😌", color: "#e8da46" },
    //     { score: 50, emoji: "😐", color: "#e7ad41" },
    //     { score: 60, emoji: "😕", color: "#e78441" },
    //     { score: 70, emoji: "🙁", color: "#e36c41" },
    //     { score: 80, emoji: "☹️", color: "#e34a41" },
    //     { score: 90, emoji: "😣", color: "#fa6262" },
    //     { score: 100, emoji: "😭", color: "#e41f1f" }
    // ]
    const vasFaces = [
        { score: 10,  fileName: "vas_score_10"  },
        { score: 20,  fileName: "vas_score_20"  },
        { score: 30,  fileName: "vas_score_30"  },
        { score: 40,  fileName: "vas_score_40"  },
        { score: 50,  fileName: "vas_score_50"  },
        { score: 60,  fileName: "vas_score_60"  },
        { score: 70,  fileName: "vas_score_70"  },
        { score: 80,  fileName: "vas_score_80"  },
        { score: 90,  fileName: "vas_score_90"  },
        { score: 100, fileName: "vas_score_100" }
    ]

    function onPageChange(page) {
        fetchExamResults(page)
    }

    const fetchExamResults = async (page = 1, id) => {
        if (filter.startDate && filter.endDate) {
            const start = new Date(filter.startDate);
            const end   = new Date(filter.endDate);

            if (start > end) {
                alert('시작일자는 종료일자보다 작거나 같아야 합니다.');
                return; // 검색 실행하지 않음
            }
        }

        const idFromRoute = route.params.patientId;
        try {
            const params = {
                startIndex: page,
                pageRow: pageSize.value,
                patientId: idFromRoute,
                ...(filter.startDate && { startDate: filter.startDate + " 00:00:00" }),
                ...(filter.endDate   && { endDate: filter.endDate + " 23:59:59" }),
                ...(
                    filter.searchType === "all" ? { all: filter.searchText } :
                    filter.searchType === "diseaseName" ? { diseaseName: filter.searchText } :
                    filter.searchType === "painArea" ? { painArea: filter.searchText } :
                    filter.searchType === "vasScore" ? { vasScore: filter.searchText } :
                    filter.searchType === "score" ? { score: filter.searchText } :
                    {}
                )
            };

            const res       = await api.post(urls.patientList.diagnosisSearch, params);
            const pageStart = (page - 1) * pageSize.value;
            
            diagnosisList.value = (res.data.list || []).map((item, index) => ({
                no          : pageStart + index + 1,                        // 순번
                id          : item.patient_id,                              //환자 id
                diagnosisId : item.id,                                      //진단 id
                examDate    : item.created_at ? item.created_at.split("T")[0] : "", //진단일
                diseaseName : item.disease_name,                            // 질환명
                part        : item.pain_area,                               // 부위
                vas         : item.vas_score,                               // VAS 점수
                score       : item.score,                                   // SCORE
                cpt         : item.cpt,                                     // CPT 점수
                pec         : item.pec,                                     // PEC 점수
                detail      : item.detail                                   // 상세내역
            }));

            totalCount.value  = res.data.totCnt;
            totalPages.value  = Math.ceil(totalCount.value / pageSize.value);
            currentPage.value = page;

        } catch (err) {
            diagnosisList.value = [];
            totalCount.value    = 0;
            totalPages.value    = 1;
            currentPage.value   = 1;
        }
    };

    function PatientData() {
        const idFromRoute = route.params.patientId;
        api.post(urls.patientList.patientData, { id: idFromRoute })
            .then(res => {
                const data = res.data.list ? res.data.list[0] : res.data; // list 배열로 올 수도 있음

                // 응답 필드 → patientInfo 매핑
                patientInfo.value = {
                    id       : data.patient_id,
                    name     : data.name,
                    birth    : data.dob || '',
                    age      : commonUtils.calcAge(data.dob),
                    weight   : data.weight,
                    lastExam : data.created_at ? data.created_at.split('T')[0] : '',
                    painArea : data.pain_area || ''
                };
            })
            .catch(err =>{
                alert("환자 정보 불러오는데 실패했습니다.")
            })
    }

    function showDetail(item) {
        router.push({
            path: `/patientlist/painProfile/${item.id}`,
            query: { diagnosisId: item.diagnosisId }
        })
    }

    // 컴포넌트 스크립트 setup 안
    function getVasFace(score) {
        // return vasFaces.find(face => face.score === score) || {};
        const s = Number(score)
        if (!Number.isFinite(s)) return null

        return `vas_score_${s}`
    }

    const onResetFilter = () => {
        // 필터 값 초기화
        filter.searchType = "all";
        filter.searchText = "";
        filter.startDate  = "";
        filter.endDate    = "";

        // 1페이지부터 다시 데이터 조회
        // fetchExamResults(1);
    };

    watch(
        () => filter.startDate,
        (newStart, oldStart) => {
            if (newStart && filter.endDate) {
                if (new Date(newStart) > new Date(filter.endDate)) {
                    alert('시작일자는 종료일자보다 작거나 같아야 합니다.');
                    filter.startDate = oldStart || '';
                }
            }
        }
    )

    watch(
        () => filter.endDate,
        (newEnd, oldEnd) => {
            if (newEnd && filter.startDate) {
                if (new Date(newEnd) < new Date(filter.startDate)) {
                    alert('종료일자는 시작일자보다 크거나 같아야 합니다.');
                    filter.endDate = oldEnd || '';
                }
            }
        }
    )

    const filterStorageKey = 'DiagnosisListFilter';

    watch(currentPage, (newPage) => {
        sessionStorage.setItem('DiagnosisListPage', newPage);
        fetchExamResults(newPage);
    });

    let watchFilterStop = null;
    onMounted(() => {
        PatientData();  // 환자 프로필 세팅
        const savedFilterString = sessionStorage.getItem(filterStorageKey);
        if (savedFilterString) {
            const savedFilter = JSON.parse(savedFilterString);
            filter.searchType = savedFilter.searchType || "all";
            filter.searchText = savedFilter.searchText || "";
            filter.startDate  = savedFilter.startDate || "";
            filter.endDate    = savedFilter.endDate || "";
        }

        watchFilterStop = watch(filter, (newVal) => {
            sessionStorage.setItem(filterStorageKey, JSON.stringify(newVal));
        }, { deep: true });

        fetchExamResults(currentPage.value);
    })
</script>
